import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormErrorService } from '@features/forms/form-error.service';
import { catchError } from 'rxjs/operators';
import { FeedbackService } from './feedback.service';

@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
})
export class FeedbackFormComponent {
  @Output() submit = new EventEmitter<void>();

  form: FormGroup = this.formBuilder.group({
    subject: ['', Validators.required],
    body: ['', Validators.required],
  });

  constructor(
    private formBuilder: FormBuilder,
    private feedbackService: FeedbackService,
    public errorService: FormErrorService,
  ) {}

  onSuccess() {
    this.errorService.onSuccess();
    this.form.reset();
    this.submit.emit();
  }

  submitForm() {
    const { subject, body } = this.form.value;

    return this.feedbackService
      .post(subject, body)
      .pipe(catchError(this.errorService.onError.bind(this.errorService)))
      .subscribe(this.onSuccess.bind(this));
  }
}
